// url默认为 `/api/${item}`， method默认为 get

const ifUseAkMyApi = window.AK_GLOBAL && window.AK_GLOBAL.renderBy && window.AK_GLOBAL.renderBy === 'ak-my';
const ifUseAkProjectApi = window.AK_GLOBAL && window.AK_GLOBAL.renderBy && window.AK_GLOBAL.renderBy === 'ak-project';

let apiOrigin = [
  // my
  'getMyIssueSummary',
  'myIssueList',
  'getIssueStatus',
  'getTodo',
  'getTodoCount',
  'setIssueStatus',
  // project
  'getProjectNum',
  'getProjectList',
  'addWatcher',
  'cancleWatcher',
  'getPermission',
  // companySwitch
  'setUserChooseRegion',
  // companyMemberSetting
  'company/memberList',
  'invitationList',
  'refusedList',
  'waitingForApprovalList',
  // query process of generating code by template
  'queryProcessOfGenerateCode',
  // get all code template
  'getCodeTemplate',
  // search git by name
  'searchGitByName',
  'rammember',
  {
    name: 'ramSync',
    id: 'ramSync',
    method: 'POST',
    urls: '/api/ramSync'
  },
  {
    name: 'addRamMember',
    id: 'addRamMember',
    method: 'POST',
    urls: '/api/addRamMember'
  },
  {
    name: 'billingStatus',
    id: 'billingStatus',
    method: 'GET',
    urls: '/api/billingStatus'
  },
  {
    name: 'memberQuotaRemain',
    id: 'memberQuotaRemain',
    method: 'GET',
    urls: '/api/memberQuotaRemain'
  },
  {
    name: 'memberQuotaRemainWithExtraNumber',
    id: 'memberQuotaRemainWithExtraNumber',
    method: 'GET',
    urls: '/api/memberQuotaRemainWithExtraNumber'
  },
  {
    name: 'convertBillingPolicy',
    id: 'convertBillingPolicy',
    method: 'POST',
    urls: '/api/convertBillingPolicy'
  },
  {
    name: 'getSupportPlanStatus',
    id: 'getSupportPlanStatus',
    method: 'GET',
    urls: '/api/supportPlanStatus'
  },
  {
    name: 'ucDoLogin',
    id: 'ucDoLogin',
    method: 'POST',
    urls: '/internal/doLogin'
  },
  {
    name: 'ucDoRegister',
    id: 'ucDoRegister',
    method: 'POST',
    urls: '/internal/doRegister'
  },
  {
    name: 'approveJoinApplication',
    id: 'approveJoinApplication',
    method: 'POST',
    urls: '/api/approveJoinApplication'
  },
  {
    name: 'rejectJoinApplication',
    id: 'rejectJoinApplication',
    method: 'POST',
    urls: '/api/rejectJoinApplication'
  },
  // search member
  'showProjectMember',
  {
    name: 'showProjectMember',
    id: 'showProjectMember',
    method: 'GET',
    urls: '/api/showProjectMember'
  },
  // search project for program
  'searchForRelation',
  // get project custom fields
  'getCustomField',
  'getCustomOption',
  'getTaobaoBattleField',
  'joinCode',
  // companyJoin
  'company/basicInfo',
  'inviteLinkStatus',
  {
    name: 'getUserProfile',
    id: 'getUserProfile',
    method: 'GET',
    urls: ifUseAkMyApi ? '/user/profile' : '/api/user/profile'
  },
  {
    name: 'setUserProfile',
    id: 'setUserProfile',
    method: 'POST',
    urls: '/api/user/profile'
  },
  {
    name: 'submitCompanyJoinApply',
    id: 'submitCompanyJoinApply',
    method: 'POST',
    urls: '/api/submitCompanyJoinApply'
  },
  {
    name: 'removeMember',
    id: 'removeMember',
    method: 'POST',
    urls: '/api/company/removeMember'
  },
  {
    name: 'setAdmin',
    id: 'setAdmin',
    method: 'POST',
    urls: '/api/company/setAdmin'
  },
  {
    name: 'cancelAdmin',
    id: 'cancelAdmin',
    method: 'POST',
    urls: '/api/company/cancelAdmin'
  },
  {
    name: 'inviteMember',
    id: 'inviteMember',
    method: 'POST',
    urls: '/api/company/invite'
  },
  {
    name: 'checkProjectName',
    id: 'checkProjectName',
    method: 'POST',
    urls: '/api/checkProjectName'
  },
  {
    name: 'updateProject',
    id: 'updateProject',
    method: 'POST',
    urls: '/api/updateProject'
  },
  {
    name: 'createGroup',
    id: 'createGroup',
    method: 'POST',
    urls: '/api/createGroup'
  },
  {
    name: 'quickNewRepo',
    id: 'quickNewRepo',
    method: 'POST',
    urls: '/api/quickNewRepo'
  },
  {
    name: 'quickNewProject',
    id: 'quickNewProject',
    method: 'POST',
    urls: '/api/quickNewProject'
  },
  {
    name: 'quickNewCodeByTemplateAndRepo',
    id: 'quickNewCodeByTemplateAndRepo',
    method: 'POST',
    urls: '/api/quickNewCodeByTemplateAndRepo'
  },
  {
    name: 'createApplication',
    id: 'createApplication',
    method: 'POST',
    urls: '/api/createApplication'
  },
  // companyCreate
  'region/searchRegion',
  {
    name: 'createNewCompany',
    id: 'createNewCompany',
    method: 'POST',
    urls: '/api/region/new'
  },
  'user/profile',
  'company/basicInfo',
  {
    name: 'updateUserProfile',
    id: 'updateUserProfile',
    method: 'POST',
    urls: '/api/user/profile'
  },
  // admin/dockerAccount
  {
    name: 'createNewConfigItem',
    id: 'createNewConfigItem',
    method: 'POST',
    urls: '/api/admin/createNewConfigItem'
  },
  {
    name: 'deleteConfigItem',
    id: 'deleteConfigItem',
    method: 'POST',
    urls: '/api/admin/deleteConfigItem'
  },
  {
    name: 'getConfigItemByRegion',
    id: 'getConfigItemByRegion',
    method: 'GET',
    urls: '/api/admin/getConfigItemByRegion'
  },
  {
    name: 'getConfigItemByName',
    id: 'getConfigItemByName',
    method: 'GET',
    urls: '/api/admin/getConfigItemByName'
  },
  {
    name: 'getContainerCertificate',
    id: 'getContainerCertificate',
    method: 'GET',
    urls: '/api/admin/getContainerCertificate'
  },
  {
    name: 'importContainerCertificate',
    id: 'importContainerCertificate',
    method: 'POST',
    urls: '/api/admin/importContainerCertificate'
  },
  {
    name: 'deleteContainerCertificate',
    id: 'deleteContainerCertificate',
    method: 'POST',
    urls: '/api/admin/deleteContainerCertificate'
  },
  // project/addGroup
  {
    name: 'newPortfolio',
    id: 'newPortfolio',
    method: 'POST',
    urls: '/api/newPortfolio'
  },
  {
    name: 'bindRepo',
    id: 'bindRepo',
    method: 'POST',
    urls: '/api/user/bindRepo'
  },
  {
    name: 'writeReleaseFile',
    id: 'writeReleaseFile',
    method: 'POST',
    urls: '/api/writeReleaseFileToGitRepo'
  },

  // portfolio
  'portfolioTree',
  'portfolioSubTree',
  'getPortfolioMiniInfo',
  'listSubPortfolios',
  'getRiskList',
  'getRiskSummary',
  {
    name: 'addRelatedComponents',
    id: 'addRelatedComponents',
    method: 'POST',
    urls: '/api/addRelatedComponents'
  },
  {
    name: 'quickNewSprint',
    id: 'quickNewSprint',
    method: 'POST',
    urls: '/api/quickNewSprint'
  },
  // 根据应用id，申请机器和临时环境，返回异步任务的id
  {
    name: 'configMachine',
    id: 'configMachine',
    method: 'POST',
    urls: '/api/configMachine'
  },
  // 根据申请机器和临时环境的任务id，查询任务的执行进度
  'queryProcessOfConfigMachine',
  // 根据创建应用的任务id，轮询任务的执行状态
  'queryProcessOfCreateApp',
  // 根据应用id,开启日常环境的构建和部署
  {
    name: 'startApplicationFlowWithTrunk',
    id: 'startApplicationFlowWithTrunk',
    method: 'POST',
    urls: '/api/startApplicationFlowWithTrunk'
  },
  // 根据应用id,查询流水线类型
  {
    name: 'getIsSystemInDiyPipelineMode',
    id: 'getIsSystemInDiyPipelineMode',
    method: 'GET',
    urls: '/api/isSystemInDiyPipelineMode'
  },
  // 增加项目成员
  {
    name: 'addMembers',
    id: 'addMembers',
    method: 'POST',
    urls: '/api/addMembers'
  },
  'getFlowInstDetail',
  'getProjectInfo',
  // 开启scrum
  {
    name: 'openScrum',
    id: 'openScrum',
    method: 'POST',
    urls: '/api/openScrum'
  },
  // 校验应用的名称是否合法
  'checkAppNameValid',
  // 查询关联的项目
  'getSpaceList',
  'getRiskRiseShowType',
  {
    name: 'setRiskRiseShowType',
    id: 'setRiskRiseShowType',
    method: 'POST',
    urls: '/api/setRiskRiseShowType'
  },
  {
    name: 'getCrpRrojectList',
    id: 'getCrpRrojectList',
    method: 'GET',
    urls: '/crp/getCrpRrojectList'
  },
  {
    name: 'migrateCrpRrojectList',
    id: 'migrateCrpRrojectList',
    method: 'POST',
    urls: '/crp/migrationCrpRrojectList'
  },
  {
    name: 'getCrpUserList',
    id: 'getCrpUserList',
    method: 'GET',
    urls: '/crp/getCrpUserList'
  },
  {
    name: 'migrateCrpUserList',
    id: 'migrateCrpUserList',
    method: 'POST',
    urls: '/crp/migrationCrpUserList'
  },
  {
    name: 'getCrpGitGroupList',
    id: 'getCrpGitGroupList',
    method: 'GET',
    urls: '/crp/getCrpGitGroupList'
  },
  {
    name: 'migrateCrpGitGroupList',
    id: 'migrateCrpGitGroupList',
    method: 'POST',
    urls: '/crp/migrationCrpGitGroupList'
  },
  {
    name: 'getCrpGitUrlList',
    id: 'getCrpGitUrlList',
    method: 'GET',
    urls: '/crp/getCrpGitUrlList'
  },
  {
    name: 'migrateCrpGitUrlList',
    id: 'migrateCrpGitUrlList',
    method: 'POST',
    urls: '/crp/migrationCrpGitUrlList'
  },
  {
    name: 'getCrpMachineList',
    id: 'getCrpMachineList',
    method: 'GET',
    urls: '/crp/getCrpMachineList'
  },
  {
    name: 'migrateCrpMachineList',
    id: 'migrateCrpMachineList',
    method: 'POST',
    urls: '/crp/migrationCrpMachineList'
  },
  {
    name: 'checkRepoMasterAccess',
    id: 'checkRepoMasterAccess',
    method: 'GET',
    urls: '/api/checkRepoMasterAccess'
  },
  /*
   * created by chifan.sdd
   * 项目的后台设置
   * */
  // 项目设置-基本设置
  'getProjectInfo',
  'getProjectInfoForDelete',
  'getCustomField',
  'searchProduct',
  'searchParentSpaces',
  'searchProSet',
  'searchPortfolio',
  'getDefaultSpaceIcons',
  'searchForRelation',
  'searchNewProduct',
  {
    name: 'updateProject',
    id: 'updateProject',
    method: 'POST',
    urls: '/api/updateProject'
  },
  {
    name: 'deleteProject',
    id: 'deleteProject',
    method: 'POST',
    urls: '/api/deleteProject'
  },
  {
    name: 'cancelTaskForDelete',
    id: 'cancelTaskForDelete',
    method: 'POST',
    urls: '/api/cancelTaskForDelete'
  },
  {
    name: 'updatePortfolio',
    id: 'updatePortfolio',
    method: 'POST',
    urls: '/api/updatePortfolio'
  },
  {
    name: 'addWatcher',
    id: 'addWatcher',
    method: 'POST',
    urls: '/api/addWatcher'
  },
  {
    name: 'cancleWatcher',
    id: 'cancleWatcher',
    method: 'POST',
    urls: '/api/cancleWatcher'
  },
  {
    name: 'setProjectActived',
    id: 'setProjectActived',
    method: 'POST',
    urls: '/api/active'
  },
  {
    name: 'setProjectArchived',
    id: 'setProjectArchived',
    method: 'POST',
    urls: '/api/archive'
  },
  // 项目设置-成员
  'getMembersForEdit',
  'listMembersForCollab',
  'getProjectRolesForEdit',
  'getProjectRoles',
  'searchBreadList',
  'exportMembers',
  'getMemberInfo',
  'getPermissionSettingInProject',
  {
    name: 'addRoleByName',
    id: 'addRoleByName',
    method: 'POST',
    urls: '/api/addRoleByName'
  },
  {
    name: 'updateRolePositionInProject',
    id: 'updateRolePositionInProject',
    method: 'POST',
    urls: '/api/updateRolePositionInProject'
  },
  {
    name: 'updateRoleInProject',
    id: 'updateRoleInProject',
    method: 'POST',
    urls: '/api/updateRoleInProject'
  },
  {
    name: 'updatePermissionInProject',
    id: 'updatePermissionInProject',
    method: 'POST',
    urls: '/api/updatePermissionInProject'
  },
  {
    name: 'updateCustomRoleType',
    id: 'updateCustomRoleType',
    method: 'POST',
    urls: '/api/updateCustomRoleType'
  },
  {
    name: 'addMembers',
    id: 'addMembers',
    method: 'POST',
    urls: '/api/addMembers'
  },
  {
    name: 'deleteMembers',
    id: 'deleteMembers',
    method: 'POST',
    urls: '/api/deleteMembers'
  },
  {
    name: 'addProjectRoles',
    id: 'addProjectRoles',
    method: 'POST',
    urls: '/api/addProjectRoles'
  },
  {
    name: 'deleteProjectRoles',
    id: 'deleteProjectRoles',
    method: 'POST',
    urls: '/api/deleteProjectRoles'
  },
  {
    name: 'updateProjectRole',
    id: 'updateProjectRole',
    method: 'POST',
    urls: '/api/updateProjectRole'
  },
  {
    name: 'importMembers',
    id: 'importMembers',
    method: 'POST',
    urls: '/api/importMembers'
  },
  {
    name: 'editMemRoles',
    id: 'editMemRoles',
    method: 'POST',
    urls: '/api/editMemRoles'
  },
  // 项目设置-公告
  'getNotice',
  {
    name: 'updateNotice',
    id: 'updateNotice',
    method: 'POST',
    urls: '/api/updateNotice'
  },
  // 项目设置-版本
  'getVersionDetail',
  'searchForEdit',
  {
    name: 'getVersionListOfProject',
    id: 'getVersionListOfProject',
    method: 'GET',
    urls: '/api/getvListOfProject'
  },
  {
    name: 'getVersionListByParent',
    id: 'getVersionListByParent',
    method: 'GET',
    urls: '/api/getListByParent'
  },
  {
    name: 'deleteVersion',
    id: 'deleteVersion',
    method: 'POST',
    urls: '/api/deleteVersion'
  },
  {
    name: 'createVersion',
    id: 'createVersion',
    method: 'POST',
    urls: '/api/newProVersion'
  },
  {
    name: 'updateVersion',
    id: 'updateVersion',
    method: 'POST',
    urls: '/api/updateProVersion'
  },
  // 项目设置-服务
  'getServices',
  {
    name: 'getMyServices',
    id: 'getMyServices',
    method: 'GET',
    urls: ifUseAkMyApi ? '/service/list' : '/api/getMyServices'
  },
  {
    name: 'configSpaceService',
    id: 'configSpaceService',
    method: 'POST',
    urls: '/api/configSpaceService'
  }, {
    name: 'configMyService',
    id: 'configMyService',
    method: 'POST',
    urls: ifUseAkMyApi ? '/service/config' : '/api/configMyService'
  },
  {
    name: 'sortServices',
    id: 'sortServices',
    method: 'POST',
    urls: '/api/sortServices'
  },
  {
    name: 'sortMyServices',
    id: 'sortMyServices',
    method: 'POST',
    urls: ifUseAkMyApi ? '/service/sort' : '/api/sortMyServices'
  },
  // 项目设置-模块
  'getModuleTree',
  'subModuleTree',
  'getModuleDetail',
  'checkPermission',
  'getParentProject',
  'inheritModuleTree',
  'inheritSubModuleTree',
  'getInheritModuleIds', // 获取已选中的ids
  {
    name: 'searchModules',
    id: 'searchModules',
    method: 'GET',
    urls: '/api/parentModules'
  },
  {
    name: 'deleteModule',
    id: 'deleteModule',
    method: 'POST',
    urls: '/api/deleteModule'
  },
  {
    name: 'createModule',
    id: 'createModule',
    method: 'POST',
    urls: '/api/createModule'
  },
  {
    name: 'updateModule',
    id: 'updateModule',
    method: 'POST',
    urls: '/api/updateModule'
  },
  {
    name: 'updateModuleOwner',
    id: 'updateModuleOwner',
    method: 'POST',
    urls: '/api/updateModuleOwner'
  },
  {
    name: 'saveInheritModules',
    id: 'saveInheritModules',
    method: 'POST',
    urls: '/api/saveInheritModules'
  },
  {
    name: 'inheritParent',
    id: 'inheritParent',
    method: 'POST',
    urls: '/api/inheritParent'
  },
  // 项目设置-里程碑
  'getLMList',
  'getModules',
  'getLMDetail',
  {
    name: 'createLandmark',
    id: 'createLandmark',
    method: 'POST',
    urls: '/api/createLandmark'
  },
  {
    name: 'updateLandmark',
    id: 'updateLandmark',
    method: 'POST',
    urls: '/api/updateLandmark'
  },
  'checkPermissionToAddProjectInDivision',
  {
    name: 'createSpace',
    id: 'createSpace',
    method: 'POST',
    urls: '/api/createSpace'
  },
  {
    name: 'selectGlobalRegionByGuid',
    id: 'selectGlobalRegionByGuid',
    method: 'GET',
    urls: '/api/selectGlobalRegionByGuid'
  },
  {
    name: 'initiateCollabProject',
    id: 'initiateCollabProject',
    method: 'POST',
    urls: '/api/initiateCollabProject'
  },
  {
    name: 'participateCollabProject',
    id: 'participateCollabProject',
    method: 'POST',
    urls: '/api/participateCollabProject'
  },
  {
    name: 'generateInviteCode',
    id: 'generateInviteCode',
    method: 'POST',
    urls: '/api/generateInviteCode'
  },
  {
    name: 'getProjectByInviteCode',
    id: 'getProjectByInviteCode',
    method: 'GET',
    urls: '/api/getProjectByInviteCode'
  },
  // 新建项目获取自定义字段
  'getProjectTemplateForCreate',
  {
    name: 'ucSendValidationEmail',
    id: 'ucSendValidationEmail',
    method: 'POST',
    type: 'text',
    urls: '/user/profile/sendValidationEmail'
  },
  {
    name: 'updateEmailWithValidationCode',
    id: 'updateEmailWithValidationCode',
    method: 'POST',
    urls: '/user/profile/updateEmailWithValidationCode'
  },
  {
    name: 'postUserProfile',
    id: 'postUserProfile',
    method: ifUseAkMyApi ? 'PUT' : 'POST',
    urls: ifUseAkMyApi ? '/user/profile' : '/api/user/profile'
  },
  {
    name: 'resetPassword',
    id: 'resetPassword',
    method: 'POST',
    urls: '/internal/resetPassword'
  },

  {
    name: 'updateLoginType',
    id: 'updateLoginType',
    method: 'POST',
    urls: '/system/updateLoginType'
  },
  {
    name: 'setRegionUserOutSource',
    id: 'setRegionUserOutSource',
    method: 'POST',
    urls: '/api/setRegionUserOutSource'
  },
  {
    name: 'setRegionUserFulltime',
    id: 'setRegionUserFulltime',
    method: 'POST',
    urls: '/api/setRegionUserFulltime'
  },
  'user/profile',
  {
    name: 'getCollabProjectSetting',
    id: 'getCollabProjectSetting',
    method: 'GET',
    urls: '/api/getCollabProjectSetting'
  },
  {
    name: 'setProjectCollab',
    id: 'setProjectCollab',
    method: 'POST',
    urls: '/api/setProjectCollab'
  },
  {
    name: 'syncHistoryDataToCollabProject',
    id: 'syncHistoryDataToCollabProject',
    method: 'POST',
    urls: '/api/collab/project/syncHistoryDataToCollabProject'
  },
  'getDingtalkSerialNumber',

  // 获取企业构建物配置内容
  'getCompanyBuildPackageConfig',

  {
    name: '获取企业构建物配置内容',
    id: 'getCompanyBuildPackageConfig',
    method: 'get',
    urls: '/api/service/company/buildPackage/config'
  },
  // 更新企业构建物配置
  'updateCompanyBuildPackageConfig',

  {
    name: '更新企业配置',
    id: 'updateCompanyBuildPackageConfig',
    method: 'get',
    urls: '/api/service/company/buildPackage/config/updateConfig'
  },
  // 获取企业应用构建物信息
  'getAppBuildPackageDetail',

  {
    name: '获取企业应用构建物信息',
    id: 'getAppBuildPackageDetail',
    method: 'get',
    urls: '/api/service/company/buildPackage/package/detail'
  },
  {
    name: '获取某成员在某企业下的权限',
    id: 'permissionList',
    method: 'get',
    urls: '/api/company/permissionList'
  }, {
    name: 'getIssueType',
    id: 'getIssueType',
    method: 'get',
    urls: '/setting/issue/type/detail'
  }, {
    name: '获取规则的列表',
    id: 'getRuleList',
    method: 'get',
    urls: '/rule/list'
  }, {
    name: '获取状态信息',
    id: 'searchStatus',
    method: 'get',
    urls: '/v3/issue/status/search'
  }, {
    name: '获取项目下过滤面板的自定义属性列表',
    id: 'getColumns',
    method: 'get',
    urls: '/v3/issue/getColumns'
  }, {
    name: '获取用户信息',
    id: 'getUserById',
    method: 'get',
    urls: '/admin/user/getUserById'
  }, {
    name: '获取规则详情',
    id: 'getRuleDetail',
    method: 'get',
    urls: '/rule/detail'
  }, {
    name: '规则保存',
    id: 'saveRule',
    method: 'post',
    urls: '/rule/save'
  }, {
    name: '规则删除',
    id: 'deleteRule',
    method: 'post',
    urls: '/rule/delete'
  }, {
    name: '规则继承字段保存',
    id: 'saveInherit',
    method: 'post',
    urls: '/rule/config/save'
  }, {
    name: '更新规则的启用字段',
    id: 'updateRuleEnable',
    method: 'post',
    urls: '/rule/config/enable'
  }, {
    name: '规则继承字段获取',
    id: 'getInherit',
    method: 'get',
    urls: '/rule/config/getInherit'
  },
  // 里程碑计划
  {
    name: '项目集里程碑计划视图获取根节点项目集信息',
    id: 'getProjectSetForMilestonePlan',
    method: 'get',
    urls: '/api/getProjectSetForMilestonePlan'
  },
  {
    name: '项目集里程碑计划视图获取关联项目信息',
    id: 'getRelatedProjectsForMilestonePlan',
    method: 'get',
    urls: '/api/getRelatedProjectsForMilestonePlan'
  },
  {
    name: '项目集里程碑计划视图获取关联项目子节点信息',
    id: 'getSubRelatedProjectsForMilestonePlan',
    method: 'get',
    urls: '/api/getSubRelatedProjectsForMilestonePlan'
  },
  {
    name: '父项目里程碑计划视图获取根节点父项目信息',
    id: 'getParentProjectForMilestonePlan',
    method: 'get',
    urls: '/api/getParentProjectForMilestonePlan'
  },
  {
    name: '父项目里程碑计划视图获取子项目信息',
    id: 'getChildProjectsForMilestonePlan',
    method: 'get',
    urls: '/api/getChildProjectsForMilestonePlan'
  },
  {
    name: '父项目里程碑计划视图获取子节点项目信息',
    id: 'getSubChildProjectsForMilestonePlan',
    method: 'get',
    urls: '/api/getSubChildProjectsForMilestonePlan'

  },
  {
    name: '关联项目里程碑计划视图获取上次使用的过滤器',
    id: 'getMilestoneRelatedProjectLastFilter',
    method: 'get',
    urls: '/api/getMilestoneRelatedProjectLastFilter'
  },
  {
    name: '父项目里程碑计划视图获取上次使用的过滤器',
    id: 'getMilestoneChildProjectLastFilter',
    method: 'get',
    urls: '/api/getMilestoneChildProjectLastFilter'
  },
  {
    name: '关联项目里程碑计划视图获取显示列',
    id: 'getMilestoneRelatedProjectColumnSetting',
    method: 'get',
    urls: '/api/getMilestoneRelatedProjectColumnSetting'
  },
  {
    name: '父项目里程碑计划视图获取显示列',
    id: 'getMilestoneChildProjectColumnSetting',
    method: 'get',
    urls: '/api/getMilestoneChildProjectColumnSetting'
  },
  {
    name: '关联项目里程碑计划视图获取显示列',
    id: 'milestoneRelatedProjectSaveColumn',
    method: 'post',
    urls: '/api/milestoneRelatedProjectSaveColumn'
  },
  {
    name: '父项目里程碑计划视图获取显示列',
    id: 'milestoneChildProjectSaveColumn',
    method: 'get',
    urls: '/api/milestoneChildProjectSaveColumn'
  },
  {
    name: '里程碑计划视图设置根节点是否展开',
    id: 'setMilestoneProjectRootNodeOpen',
    method: 'post',
    urls: '/api/setMilestoneProjectRootNodeOpen'
  },
  {
    name: '重置特定角色的项目成员',
    id: 'resetProjectMembersByRole',
    method: 'post',
    urls: '/api/resetProjectMembersByRole'
  },
  {
    name: '获取支持的部署系统列表',
    id: 'availableDeployOptions',
    method: 'get',
    urls: '/ec/ajax/availableDeployOptions'
  },
  {
    name: '购买ECS机器',
    id: 'buyEcsMachine',
    method: 'post',
    urls: '/expand/service/company/buyEcsMachine'
  },
  {
    name: '查询机器状态',
    id: 'getEcsMachineStatus',
    method: 'get',
    urls: '/expand/service/company/getEcsMachineStatus'
  },
  {
    name: '获取用户配置的第三方代码库',
    id: 'getThirdCodeRepoList',
    method: 'get',
    urls: '/api/service/getThirdCodeReopList'
  },
  {
    name: '获取当前企业的授权信息',
    id: 'getRamAuthorization',
    method: 'get',
    urls: '/expand/service/company/ram/authorization/detail'
  },
  {
    name: 'ram云效授权',
    id: 'addRdcRamAuthorization',
    method: 'post',
    urls: '/expand/service/company/ram/authorization/add'
  }, {
    name: 'ram云效重新授权',
    id: 'updateRdcRamAuthorization',
    method: 'post',
    urls: '/expand/service/company/ram/authorization/update'
  }, {
    name: '删除ram云效授权',
    id: 'deleteRdcRamAuthorization',
    method: 'post',
    urls: '/expand/service/company/ram/authorization/delete'
  }, {
    name: '检查ram是否有默认授权账户',
    id: 'checkRdcRamAuthorization',
    method: 'get',
    urls: '/expand/service/company/ram/authorization/check'
  }, {
    name: '获取过滤器的数据',
    id: 'getFilterBoard',
    method: 'get',
    urls: '/v3/issue/getFilterBoard'
  },
  // 获取镜像模板列表
  'getImageTemplateList',
  {
    name: 'getBlackBoard',
    id: 'getBlackBoard',
    method: 'get',
    urls: ifUseAkMyApi ? '/news/list' : '/api/getBlackBoard'
  },
  'getMyWatched',
  'getBranch',
  {
    name: '获取镜像模板列表',
    id: 'getImageTemplateList',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getImageTemplateList'
  },
  // 删除镜像模板
  'delEcsTemplate',
  {
    name: '删除镜像模板',
    id: 'delEcsTemplate',
    method: 'post',
    urls: '/expand/service/company/ecsTemplateManage/delEcsTemplate'
  },
  // 添加镜像模板
  'addEcsTemplate',
  {
    name: '添加镜像模板',
    id: 'addEcsTemplate',
    method: 'post',
    urls: '/expand/service/company/ecsTemplateManage/addEcsTemplate'
  },
  // 更新镜像模板
  'updateEcsTemplate',
  {
    name: '更新镜像模板',
    id: 'updateEcsTemplate',
    method: 'post',
    urls: '/expand/service/company/ecsTemplateManage/updateEcsTemplate'
  },
  // 根据id获取EcsTemplate
  'fetchEcsTemplate',
  {
    name: '根据ID获取EcsTemplate',
    id: 'fetchEcsTemplate',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/fetchEcsTemplate'
  },
  'getImageByRegion',
  {
    name: '获取当前region下的image',
    id: 'getImageByRegion',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getImageByRegion'
  },
  'getSecurityGroupByRegion',
  {
    name: '获取当前region下的安全组',
    id: 'getSecurityGroupByRegion',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getSecurityGroupByRegion'
  },
  'getVpcByRegion',
  {
    name: '获取当前region下的vpc',
    id: 'getVpcByRegion',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getVpcByRegion'
  },
  'getVswitchByRegion',
  {
    name: '获取当前region下的vSwitch',
    id: 'getVswitchByRegion',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getVswitchByRegion'
  },
  'getResourceSpecificationByRegion',
  {
    name: '获取资源你规格',
    id: 'getResourceSpecificationByRegion',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getResourceSpecificationByRegion'
  },
  'getRegionMachines',
  {
    name: '获取当前企业下机器列表',
    id: 'getRegionMachines',
    method: 'get',
    urls: '/expand/service/company/machine/getRegionMachines'
  },
  'getAddMachineCommand',
  {
    name: '获取添加机器命令',
    id: 'getAddMachineCommand',
    method: 'get',
    urls: '/expand/service/company/machine/getAddMachineCommand'
  },
  'updateMachine',
  {
    name: '更新机器相关信息',
    id: 'updateMachine',
    method: 'post',
    urls: '/expand/service/company/machine/updateMachine'
  },
  'removeMachine',
  {
    name: '删除机器',
    id: 'removeMachine',
    method: 'post',
    urls: '/expand/service/company/machine/removeMachine'
  },
  'getEcsHistoryList',
  {
    name: '获取当前企业购买机器历史',
    id: 'getEcsHistoryList',
    method: 'get',
    urls: '/expand/service/company/ecs/getEcsHistoryList'
  },
  'getEcsHistoryById',
  {
    name: '获取购买机器状态',
    id: 'getEcsHistoryById',
    method: 'get',
    urls: '/expand/service/company/ecs/getEcsHistoryById'
  },
  'getBuildImageList',
  {
    name: '获取当前region下的构建镜像列表',
    id: 'getBuildImageList',
    method: 'get',
    urls: '/api/getBuildImageList'
  },
  'insertBuildImage',
  {
    name: '新增构建镜像',
    id: 'insertBuildImage',
    method: 'post',
    urls: '/api/buildImage/insert'
  },
  'updateBuildImage',
  {
    name: '更新构建镜像',
    id: 'updateBuildImage',
    method: 'post',
    urls: '/api/buildImage/update'
  },
  {
    name: '导出里程碑',
    id: 'exportMilestone',
    method: 'post',
    urls: '/api/exportMilestone'
  },
  'getResourceSpecificationByRegion',
  {
    name: '获取资源规格',
    id: 'getResourceSpecificationByRegion',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getResourceSpecificationByRegion'
  },
  'getDiskTypeByRegionAndResource',
  {
    name: '根据区域和资源规格获取磁盘类型',
    id: 'getDiskTypeByRegionAndResource',
    method: 'get',
    urls: '/expand/service/company/ecsTemplateManage/getDiskTypeByRegionAndResource'
  },
  'getQuota',
  {
    name: '获取资源配额情况',
    id: 'getQuota',
    method: 'get',
    urls: '/api/anonymous/getQuota'
  },
  'queryImagePullRecord',
  {
    name: '获取镜像下载的情况',
    id: 'queryImagePullRecord',
    method: 'get',
    urls: '/api/buildImage/getRecordList'
  },
  {
    name: '删除里程碑',
    id: 'deleteMilestone',
    method: 'post',
    urls: '/api/deleteMilestone'
  },
  {
    name: '添加到钉钉日历',
    id: 'addToDingdingCalendar',
    method: 'get',
    urls: '/api/addToDingdingCalendar'
  },
  {
    name: '搜索标签',
    id: 'searchTags',
    method: 'get',
    urls: '/api/searchTags'
  },
  {
    name: '添加标签',
    id: 'newProjectTag',
    method: 'post',
    urls: '/api/newProjectTag'
  },
  {
    name: '删除标签',
    id: 'delTaggingProject',
    method: 'post',
    urls: '/api/deleteTag'
  },
  {
    name: '编辑标签',
    id: 'updateProjectTag',
    method: 'post',
    urls: '/api/updateProjectTag'
  },
  {
    name: '分享标签',
    id: 'shareTags',
    method: 'post',
    urls: '/api/shareTags'
  },
  'deleteBuildImage',
  {
    name: '删除构建镜像',
    id: 'deleteBuildImage',
    method: 'post',
    urls: '/api/buildImage/delete'
  },
  {
    name: '查询是否支持购买机器',
    id: 'geBuyEcsSupport',
    method: 'get',
    urls: '/expand/service/company/machine/buyEcsSupport'
  },
  {
    name: '搜索项目',
    id: 'searchProjectList',
    method: 'get',
    urls: 'issue/searchProjectList'
  },
  {
    name: '里程碑计划页面子项目列表获取单个项目节点',
    id: 'childProjectItemForMilestone',
    method: 'get',
    urls: '/api/childProjectItemForMilestone'
  },
  {
    name: '里程碑计划页面关联项目列表获取单个项目节点',
    id: 'relatedProjectItemForMilestone',
    method: 'get',
    urls: '/api/relatedProjectItemForMilestone'
  },
  {
    name: '项目资源接口获取分组及投入',
    id: 'listResourceGroupAndInvestment',
    method: 'get',
    urls: '/api/listResourceGroupAndInvestment'
  },
  {
    name: '里程碑计划页面批量更新里程碑计划完成时间',
    id: 'batchUpdateMilestoneEndDate',
    method: 'post',
    urls: '/api/batchUpdateMilestoneEndDate'
  },
  {
    name: '搜索项目标签',
    id: 'searchProjectTags',
    method: 'get',
    urls: '/api/searchTags'
  },
  {
    name: '保存里程碑计划页面过滤器',
    id: 'saveMilestonePlanFilter',
    method: 'post',
    urls: '/api/saveMilestonePlanFilter'
  },
  {
    name: '资源管理隐藏角色分组成员',
    id: 'resourceHideMembersInRole',
    method: 'post',
    urls: '/api/resourceHideMembersInRole'
  },
  {
    name: '资源管理隐藏角色分组',
    id: 'resourceHideRoleInGroup',
    method: 'post',
    urls: '/api/resourceHideRoleInGroup'
  },
  {
    name: '资源管理删除自定义分组成员',
    id: 'resourceRemoveMemberFromCustomGroup',
    method: 'post',
    urls: '/api/resourceRemoveMemberFromCustomGroup'
  },
  {
    name: '资源管理删除自定义分组',
    id: 'resourceDeleteCustomGroup',
    method: 'post',
    urls: '/api/resourceDeleteCustomGroup'
  },
  {
    name: '资源管理添加自定义分组',
    id: 'resourceAddCustomGroup',
    method: 'post',
    urls: '/api/resourceAddCustomGroup'
  },
  {
    name: '资源管理获取用户分组选择',
    id: 'resourceGetResourceGroupView',
    method: 'get',
    urls: '/api/resourceGetResourceGroupView'
  },
  {
    name: '资源管理保存用户分组选择',
    id: 'resourceSaveResourceGroupView',
    method: 'post',
    urls: '/api/resourceSaveResourceGroupView'
  },
  {
    name: '获取被隐藏的角色分组',
    id: 'resourceListHiddenRoleGroup',
    method: 'get',
    urls: '/api/resourceListHiddenRoleGroup'
  },
  {
    name: '获取自定义分组',
    id: 'resourceGetCustomGroupList',
    method: 'get',
    urls: '/api/resourceGetCustomGroupList'
  },
  {
    name: '获取自定义分组可选用户',
    id: 'resourceGetOptionalMembersForCustomGroup',
    method: 'get',
    urls: '/api/resourceGetOptionalMembersForCustomGroup'
  },
  {
    name: '获取角色分组可选用户',
    id: 'resourceListHiddenMembers',
    method: 'get',
    urls: '/api/resourceListHiddenMembers'
  },
  {
    name: '增加角色分组成员',
    id: 'resourceShowMembersInRole',
    method: 'post',
    urls: '/api/resourceShowMembersInRole'
  },
  {
    name: '增加自定义分组成员',
    id: 'resourceAddMemberToCustomGroup',
    method: 'post',
    urls: '/api/resourceAddMemberToCustomGroup'
  },
  {
    name: '编辑自定义分组',
    id: 'resourceUpdateCustomGroup',
    method: 'post',
    urls: '/api/resourceUpdateCustomGroup'
  },
  {
    name: '保存成员投入',
    id: 'saveResourceMemberInvestment',
    method: 'post',
    urls: '/api/saveResourceMemberInvestment'
  },
  {
    name: '删除成员投入',
    id: 'deleteResourceMemberInvestment',
    method: 'post',
    urls: '/api/deleteResourceMemberInvestment'
  },
  {
    name: '获取项目公告列表',
    id: 'listProjectAnnouncements',
    method: 'get',
    urls: '/api/listProjectAnnouncements'
  },
  {
    name: '里程碑计划关联项目显示列配置',
    id: 'getMilestoneRelatedProjectListColumns',
    method: 'get',
    urls: '/api/getMilestoneRelatedProjectListColumns'
  },
  {
    name: '里程碑计划子项目显示列配置',
    id: 'getMilestoneChildProjectListColumns',
    method: 'get',
    urls: '/api/getMilestoneChildProjectListColumns'
  },
  {
    name: '获取用户mini信息',
    id: 'getUserMiniInfo',
    method: 'get',
    urls: '/api/getUserMiniInfo'
  },
  {
    name: '添加关联项目',
    id: 'addRelatedProjects',
    method: 'POST',
    urls: '/api/addRelatedPro'
  },
  {
    name: '获取用户在项目中的权限',
    id: 'getPermissionInProject',
    method: 'GET',
    urls: '/api/getPermissionInProject'
  },
  {
    name: '设置项目需求锁定',
    id: 'configProjectReqLock',
    method: 'POST',
    urls: '/api/configProjectReqLock'
  },
  {
    name: '退出项目',
    id: 'quitProject',
    method: 'POST',
    urls: '/api/quitProject'
  },
  {
    name: '收藏项目',
    id: 'watchProject',
    method: 'POST',
    urls: '/api/addWatcher'
  },
  {
    name: '取消收藏项目',
    id: 'cancelWatchProject',
    method: 'POST',
    urls: '/api/cancleWatcher'
  },
  {
    name: '获取项目信息-概述页',
    id: 'getProjectDetail',
    method: 'GET',
    urls: '/api/getProjectDetail'
  },
  {
    name: '获取立项审批状态',
    id: 'appInitGetApprovalStatus',
    method: 'GET',
    urls: '/api/appInitGetApprovalStatus'
  },
  {
    name: '获取立项模板',
    id: 'appInitGetTemplate',
    method: 'GET',
    urls: '/api/appInitGetTemplate'
  },
  {
    name: '创建立项审批单',
    id: 'appInitNew',
    method: 'POST',
    urls: '/api/appInitNew'
  },
  {
    name: '获取成员列表(概述页)',
    id: 'getMemberList',
    method: 'GET',
    urls: '/api/getMemberList'
  },
  {
    name: '获取项目动态',
    id: 'getActivities',
    method: 'GET',
    urls: '/api/getActivities'
  },
  {
    name: '获取单个项目的里程碑数据',
    id: 'getLMTimeline',
    method: 'POST',
    urls: '/api/getLMTimeline'
  },
  {
    name: '搜索AoneData数据模块',
    id: 'searchAoneDataInTerm',
    method: 'get',
    urls: '/doc/searchAoneDataInTerm'
  },
  {
    name: '获取当前项目下所有关联的词条',
    id: 'getAllTermsInScope',
    method: 'get',
    urls: '/doc/getAllTermsInScope'
  },
  {
    name: '根据词条ID获取当前项目下的引用',
    id: 'getTermReferenceByTermIdInScope',
    method: 'get',
    urls: '/doc/getTermReferenceByTermIdInScope'
  },
  {
    name: '在当前项目下关联词条和引用',
    id: 'createTermAndAssociateToReference',
    method: 'POST',
    urls: '/doc/createTermAndAssociateToReference'
  },
  {
    name: '删除词条',
    id: 'deleteTerm',
    method: 'POST',
    urls: '/doc/deleteTermInScope'
  },
  {
    name: '获取词条引用',
    id: 'getTermReferenceByTermIdInScope',
    method: 'get',
    urls: '/doc/getTermReferenceByTermIdInScope'
  },
  {
    name: '关联项目树根节点',
    id: 'relatedProjectTree',
    method: 'POST',
    urls: '/api/relatedProjectTree'
  },
  {
    name: '子项目树根节点',
    id: 'childProjectTree',
    method: 'POST',
    urls: '/api/childProjectTree'
  },
  {
    name: '关联项目树根节点',
    id: 'relatedProjectSubTree',
    method: 'POST',
    urls: '/api/relatedProjectSubTree'
  },
  {
    name: '子项目树子节点',
    id: 'childProjectSubTree',
    method: 'POST',
    urls: '/api/childProjectSubTree'
  },
  {
    name: '概述页获取变更列表',
    id: 'searchCRList',
    method: 'get',
    urls: '/ec/ajax/base/service/search'
  },
  {
    name: '概述页变更列表获取成员信息',
    id: 'getCRListUsers',
    method: 'POST',
    urls: '/ec/ajax/users'
  },
  {
    name: '概述页变更环形图数据',
    id: 'getCRChart',
    method: 'get',
    urls: '/ec/ajax/project/kelude/cr/charts'
  },
  {
    name: '概述页Aone2变更项目环境查询',
    id: 'queryAone2Env',
    method: 'get',
    urls: '/ec/ajax/aone2/test/env/query'
  },
  {
    name: '概述页新版变更项目环境查询',
    id: 'queryEnv',
    method: 'get',
    urls: '/ec/ajax/test/env/query'
  },
  {
    name: 'listK8sCluster',
    id: 'listK8sCluster',
    method: 'GET',
    urls: '/api/admin/listK8sCluster'
  },
  {
    name: 'importK8sClusterCert',
    id: 'importK8sClusterCert',
    method: 'POST',
    urls: '/api/admin/importK8sClusterCert'
  },
  {
    name: 'removeK8sCluster',
    id: 'removeK8sCluster',
    method: 'POST',
    urls: '/api/admin/removeK8sCluster'
  },
  {
    name: '概述页布局配置弹框获取布局信息',
    id: 'getPanelSetting',
    method: 'get',
    urls: '/api/getPanelSetting'
  },
  {
    name: '保存概述页布局配置',
    id: 'savePanelSetting',
    method: 'POST',
    urls: '/api/savePanelSetting'
  },
  {
    name: '概述页获取布局配置',
    id: 'getOrderedPanels',
    method: 'get',
    urls: '/api/getOrderedPanels'
  },
  {
    name: '获取aone2的项目id',
    id: 'getAone2Id',
    method: 'get',
    urls: '/api/getAone2Id'
  },
  {
    name: '记录最近访问的项目',
    id: 'recordRecentVisit',
    method: 'post',
    urls: '/api/recordRecentVisit'
  },
  {
    name: '查询私有云代理机列表',
    id: 'listPrivateProxyMachine',
    method: 'get',
    urls: '/expand/service/company/machine/listPrivateProxyMachine'
  },
  {
    name: '查询私有云代理机',
    id: 'getPrivateProxyMachine',
    method: 'get',
    urls: '/expand/service/company/machine/getPrivateProxyMachine'
  },
  {
    name: '查询私有云代理机列表',
    id: 'addPrivateProxyMachine',
    method: 'post',
    urls: '/expand/service/company/machine/addPrivateProxyMachine'
  },
  {
    name: '查询私有云代理机列表',
    id: 'updatePrivateProxyMachine',
    method: 'post',
    urls: '/expand/service/company/machine/updatePrivateProxyMachine'
  },
  {
    name: '查询私有云代理机列表',
    id: 'delPrivateProxyMachine',
    method: 'post',
    urls: '/expand/service/company/machine/delPrivateProxyMachine'
  }, {
    name: '保存手动导入的集群',
    id: 'saveManualInputK8sCluster',
    method: 'post',
    urls: '/api/admin/saveManualInputK8sCluster'
  }, {
    name: '获取关联项目列表的过滤条件',
    id: 'relatedProjectListFilter',
    method: 'get',
    urls: '/api/lastFilter'
  }, {
    name: '获取子项目列表的过滤条件',
    id: 'childProjectListFilter',
    method: 'get',
    urls: '/api/childProjectLastFilter'
  }, {
    name: '项目列表过滤器',
    id: 'simpleFilters',
    method: 'get',
    urls: '/api/simpleFilters'
  }, {
    name: '根据代码地址获取开发模式',
    id: 'getDevModelByCodeModule',
    method: 'get',
    urls: '/api/getDevModelByCodeModule'
  }, {
    name: '查看git组是否存在',
    id: 'checkGitGroupExist',
    method: 'get',
    urls: '/api/checkGitGroupExist'
  },
  {
    name: '获取甘特图根节点',
    id: 'getGanttTreeRoot',
    method: 'get',
    urls: '/api/getGanttTreeRoot'
  },
  {
    name: '获取甘特图子节点',
    id: 'getGanttSubNode',
    method: 'get',
    urls: '/api/getGanttSubNode'
  },
  {
    name: '获取甘特图显示列',
    id: 'getGanttColumns',
    method: 'get',
    urls: '/api/getGanttColumns'
  },
  {
    name: '保存甘特图显示列',
    id: 'saveGanttColumns',
    method: 'post',
    urls: '/api/saveGanttColumns'
  },
  {
    name: '保存甘特图过滤器',
    id: 'saveGanttFilter',
    method: 'get',
    urls: '/api/saveGanttFilter'
  },
  {
    name: '获取甘特图过滤器',
    id: 'getGanttFilter',
    method: 'get',
    urls: '/api/getGanttFilter'
  },
  {
    name: '获取里程碑计划上次访问的视图模式',
    id: 'getGanttLastView',
    method: 'get',
    urls: '/api/getGanttLastView'
  },
  {
    name: '保存里程碑计划上次访问的视图模式',
    id: 'saveGanttView',
    method: 'post',
    urls: '/api/saveGanttView'
  },
  {
    name: '获取甘特图上的单个树节点',
    id: 'getGanttTreeNode',
    method: 'get',
    urls: '/api/getGanttTreeNode'
  },
  {
    name: '获取甘特图规划页任务列表',
    id: 'ganttPlanning',
    method: 'get',
    urls: '/api/ganttPlanning'
  },
  {
    name: '获取甘特图规划页任务列表子节点',
    id: 'ganttPlanningSubNodes',
    method: 'get',
    urls: '/api/ganttPlanningSubNodes'
  },
  {
    name: '保存甘特图规划',
    id: 'addToGantt',
    method: 'get',
    urls: '/api/addToGantt'
  },
  {
    name: '更新甘特图上的工作项', // 不仅仅甘特在使用，里程碑更新工作项也在使用
    id: 'updateIssueForGantt',
    method: 'post',
    urls: '/api/updateIssueForGantt'
  }, {
    name: '查看region下的所有docker认证信息',
    id: 'getDockerAccountList',
    method: 'get',
    urls: '/dockerAccount/list'
  }, {
    name: '增加docker账号密码认证信息',
    id: 'addDockerAccount',
    method: 'post',
    urls: '/dockerAccount/add'
  }, {
    name: '删除docker账号密码认证信息',
    id: 'removeDockerAccount',
    method: 'post',
    urls: '/dockerAccount/delete'
  }, {
    name: '更新docker账号密码认证信息',
    id: 'updateDockerAccount',
    method: 'post',
    urls: '/dockerAccount/update'
  }, {
    name: '获取当前企业所有可用的镜像仓库region信息',
    id: 'getDockerRegistryRegionList',
    method: 'get',
    urls: '/dockerRegistry/region/list'
  }, {
    name: '搜索标签',
    id: 'searchTags',
    method: 'get',
    urls: '/api/tag/searchTags'
  }, {
    name: '打标签',
    id: 'taggingProject',
    method: 'post',
    urls: '/api/tag/taggingProject'
  }, {
    name: '修改标签标签',
    id: 'updateTag',
    method: 'post',
    urls: '/api/tag/updateProjectTag'
  }, {
    name: '取消标签',
    id: 'removeTaggingProject',
    method: 'post',
    urls: '/api/tag/delTaggingProject'
  }, {
    name: '新建标签',
    id: 'newProjectTag',
    method: 'post',
    urls: '/api/tag/newProjectTag'
  },
  {
    name: '获取当前企业region下所有的镜像仓库',
    id: 'getDockerRegistryRegionRepoList',
    method: 'get',
    urls: '/dockerRegistry/repo/list'
  },
  {
    name: '关联项目列表配置显示列',
    id: 'relatedProSaveColumn',
    method: 'post',
    urls: '/api/saveColSetting'
  },
  {
    name: '关联项目列表获取显示列配置',
    id: 'relatedProGetColSetting',
    method: 'get',
    urls: '/api/relatedProjectListColumns'
  },
  {
    name: '子项目列表配置显示列',
    id: 'childProSaveColumn',
    method: 'post',
    urls: '/api/saveColumn'
  },
  {
    name: '子项目列表获取显示列配置',
    id: 'childProGetColSetting',
    method: 'get',
    urls: '/api/childProjectListColumns'
  },
  {
    name: '获取项目模板列表',
    id: 'listProjectTemplates',
    method: 'get',
    urls: '/api/listProjectTemplates'
  },
  {
    name: '新建项目时获取项目模板',
    id: 'getProjectTemplateV2',
    method: 'get',
    urls: '/api/getProjectTemplateV2'
  },
  {
    name: '更新项目时获取项目模板',
    id: 'getProjectTemplateWhenUpdateV2',
    method: 'get',
    urls: '/api/getProjectTemplateWhenUpdateV2'
  }, {
    name: '发送钉钉刷版本消息',
    id: 'sendRefreshVersionMessage',
    method: 'get',
    urls: '/api/sendRefreshVersionMessage'
  },
  {
    name: '更新项目时获取项目模板',
    id: 'getCustomFieldV2',
    method: 'get',
    urls: '/api/getCustomFieldV2'
  },
  {
    name: '关联项目列表&子项目列表保存过滤器',
    id: 'saveProjectListFilter',
    method: 'post',
    urls: '/api/saveProjectListFilter'
  },
  {
    name: '关联项目列表获取根节点',
    id: 'relatedProjectRoot',
    method: 'get',
    urls: '/api/relatedProjectRoot'
  },
  {
    name: '子项目列表获取根节点',
    id: 'childProjectRoot',
    method: 'get',
    urls: '/api/childProjectRoot'
  }, {
    name: '获取里程碑关联信息',
    id: 'listMilestoneRelation',
    method: 'get',
    urls: '/api/listMilestoneRelation'
  }, {
    name: '插入里程碑关联信息',
    id: 'addMilestoneRelation',
    method: 'post',
    urls: '/api/addMilestoneRelation'
  }, {
    name: '删除里程碑关联信息',
    id: 'delMilestoneRelation',
    method: 'post',
    urls: '/api/delMilestoneRelation'
  }, { id: 'milestoneCreateIssueAndRelation',
    name: '创建工作项并关联里程碑',
    method: 'post',
    urls: '/api/milestoneCreateIssueAndRelation',
  }, { id: 'simpleIssueSearch',
    name: '搜索工作项',
    method: 'get',
    urls: '/api/simpleIssueSearch',
  }, {
    name: '分享里程碑',
    id: 'copyMilestone',
    method: 'post',
    urls: '/api/copyMilestone'
  }, {
    name: '获取项目自定义属性',
    id: 'getCustomValues',
    method: 'get',
    urls: '/api/getCustomValues'
  },
  {
    name: '获取企业下的码云认证信息',
    id: 'getMayunCredential',
    method: 'get',
    urls: '/code/gitee/credential/get'
  },
  {
    name: '删除企业下的码云认证信息',
    id: 'removeMayunCredential',
    method: 'post',
    urls: '/code/gitee/credential/delete'
  },
  {
    name: '获取授权用户的码云仓库',
    id: 'getMayunRepoList',
    method: 'get',
    urls: '/code/repo/list'
  }, {
    name: '根据id获取项目模板详情',
    id: 'getProjectTemplateInfo',
    method: 'get',
    urls: '/api/getProjectTemplateInfo'
  },
  {
    name: '查询阿里云ECS列表',
    id: 'getAliyunEcsList',
    method: 'get',
    urls: '/expand/service/company/machine/getAliyunEcsList'
  },
  {
    name: '导入阿里云ECS',
    id: 'importAliyunEcs',
    method: 'post',
    urls: '/expand/service/company/machine/importAliyunEcs'
  },
  {
    name: '添加子项目',
    id: 'addChildProjects',
    method: 'post',
    urls: '/api/addChildProjects'
  },
  {
    name: '获取项目成员角色列表',
    id: 'getRoles',
    method: 'get',
    urls: '/projects/member/getRoles',
  },
  {
    name: '批量更新成员角色',
    id: 'batchUpdateRoles',
    method: 'post',
    urls: '/projects/member/batchUpdateRoles',
  },
  {
    name: '获取项目角色',
    id: 'getRoleStatisticData',
    method: 'get',
    urls: '/projects/member/getRoleStatisticData',
  },
  {
    name: '获取项目现有模板信息',
    id: 'getProjectTemplateDetail',
    method: 'get',
    urls: '/projects/project/getProjectTemplate',
  },
  {
    name: '获取模板为业务空间的子项目',
    id: 'getChildrenHasBusinessTemplate',
    method: 'get',
    urls: '/projects/project/filterChildrenHasBusinessTemplate',
  },
  {
    name: '判断当前时间是否合法',
    id: 'checkCurrentDateIsLegal',
    method: 'get',
    urls: '/projects/project/checkCurrentDateIsLegal',
  },
  {
    name: '获取待转交的项目列表',
    id: 'getResignationList',
    method: 'get',
    urls: '/projects/resignation/list',
  },
  {
    name: '转交项目',
    id: 'transferProject',
    method: 'post',
    urls: '/projects/resignation/transfer',
  },
  {
    name: '批量转交项目',
    id: 'batchTransferProjects',
    method: 'post',
    urls: '/projects/resignation/batchTransfer',
  },
  {
    name: '删除未审批通过的草稿态项目',
    id: 'deleteUnapprovedProject',
    method: 'post',
    urls: '/projects/project/deleteUnapprovedProject',
  },
  {
    name: '查询repo绑定的企业信息',
    id: 'checkUserRepoStatus',
    method: 'get',
    urls: '/intro/api/checkUserRepoStatus',
  },
  {
    name: '新建流水线',
    id: 'createPipeline',
    method: 'post',
    urls: '/intro/api/createPipeline',
  },
  {
    name: '读取bu信息',
    id: 'getBuInfo',
    method: 'get',
    urls: '/projects/project/getBuInfo',
  },
  {
    name: '搜索BU下的部门信息',
    id: 'searchDepartmentInBu',
    method: 'get',
    urls: '/projects/project/searchDivisionInBu',
  },
  {
    name: '读取Bu对应的部门信息',
    id: 'getDivisionOfBu',
    method: 'get',
    urls: '/projects/project/getDivisionByBuCode',
  },
  {
    name: '搜索负责的部门模板',
    id: 'searchOwnedTemplate',
    method: 'get',
    urls: '/projects/project/template/search',
  },
  {
    name: '添加模板生效部门',
    id: 'addTemplateScope',
    method: 'post',
    urls: '/projects/project/template/addScope',
  },
  {
    name: '删除模板生效部门',
    id: 'deleteTemplateScope',
    method: 'post',
    urls: '/projects/project/template/deleteScope',
  },
  {
    name: '读取模板详情',
    id: 'getTemplateDetails',
    method: 'get',
    urls: '/projects/project/template/detail',
  },
  {
    name: '读取部门模板基本信息',
    id: 'getDivisionTemplate',
    method: 'get',
    urls: '/projects/project/template/getDivisionTemplate',
  },
  {
    name: '读取模板的自定义属性列表',
    id: 'getProjectTemplateCustomFieldList',
    method: 'get',
    urls: '/projects/project/template/customField/list',
  },
  {
    name: '搜索自定义属性',
    id: 'searchCustomField',
    method: 'get',
    urls: '/projects/project/template/customField/search',
  },
  {
    // node 未实现
    name: 'getTbProjectGroup',
    id: 'getTbProjectGroup',
    method: 'get',
    urls: 'xxxxxx'
  },
  {
    name: '添加自定义属性到项目模板中',
    id: 'addProjectTemplateCf',
    method: 'post',
    urls: '/projects/project/template/customField/add',
  },
  {
    name: '从项目模板中移除自定义属性',
    id: 'removeProjectTemplateCf',
    method: 'post',
    urls: '/projects/project/template/customField/remove'
  },
  {
    name: '编辑项目模板中的自定义属性',
    id: 'updateProjectTemplateCf',
    method: 'post',
    urls: '/projects/project/template/customField/update'
  },
  {
    name: '获取项目模板配置的里程碑',
    id: 'getMilestonesInProjectTemplate',
    method: 'get',
    urls: '/projects/project/template/milestone/list'
  },
  {
    name: '添加项目模板中的里程碑',
    id: 'addMilestoneInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/milestone/add'
  },
  {
    name: '删除项目模板中的里程碑',
    id: 'deleteMilestoneInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/milestone/delete'
  },
  {
    name: '更新项目模板中的里程碑信息',
    id: 'updateMilestoneInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/milestone/update'
  },
  {
    name: 'fetchMachineGroupList',
    id: 'fetchMachineGroupList',
    method: 'GET',
    urls: '/expand/service/company/machine/group/listByRegion'
  },
  {
    name: 'createMachineGroup',
    id: 'createMachineGroup',
    method: 'POST',
    urls: '/expand/service/company/machine/group/create'
  },
  {
    name: 'deleteMachineGroup',
    id: 'deleteMachineGroup',
    method: 'POST',
    urls: '/expand/service/company/machine/group/delete'
  },
  {
    name: 'updateMachineGroup',
    id: 'updateMachineGroup',
    method: 'POST',
    urls: '/expand/service/company/machine/group/update'
  },
  {
    name: 'batchSetMachineGroup',
    id: 'batchSetMachineGroup',
    method: 'POST',
    urls: '/expand/service/company/machine/batchSetGroup'
  },
  {
    name: 'removeCodeAccessOfRegion',
    id: 'removeCodeAccessOfRegion',
    method: 'POST',
    urls: '/api/removeCodeAccessOfRegion'
  },
  {
  name: 'checkMemberHasRepoAccess',
  id: 'checkMemberHasRepoAccess',
  method: 'GET',
  urls: '/api/checkMyProjectsAndGroupsExist'
  },
  {
    name: '更新项目模板中里程碑的位置',
    id: 'exchangePositionOfMilestoneInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/milestone/exchangePosition',
  },
  {
    name: '读取当前模板的立项审批自定义属性',
    id: 'getApprovalCfListInProjectTemplate',
    method: 'get',
    urls: '/projects/project/template/approval/customField/list'
  },
  {
    name: '开启当前模板的立项审批',
    id: 'enableApprovalInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/approval/enable'
  },
  {
    name: '添加当前模板立项审批的自定义属性',
    id: 'addApprovalCfInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/approval/customField/add',
  },
  {
    name: '删除当前模板立项审批的自定义属性',
    id: 'removeApprovalCfInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/approval/customField/remove',
  },
  {
    name: '读取当前模板配置的规则',
    id: 'getRuleListInProjectTemplate',
    method: 'get',
    urls: '/projects/project/template/rules/list'
  },
  {
    name: '读取项目模板的规则',
    id: 'getAllRuleInProjectTemplate',
    method: 'get',
    urls: '/projects/project/rule/list',
  },
  {
    name: '在当前模板中配置规则',
    id: 'setRuleInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/rule/add',
  },
  {
    name: '更新当前模板中的规则配置',
    id: 'updateRuleInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/rule/update',
  },
  {
    name: '删除当前模板中的规则配置',
    id: 'deleteRuleInProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/rule/delete',
  },
  {
    name: '搜索用户',
    id: 'searchUser',
    method: 'get',
    urls: '/projects/user/search',
  },
  {
    name: '获取用户信息',
    id: 'getMiniUserInfo',
    method: 'get',
    urls: '/projects/user/getUserMiniInfo',
  },
  {
    name: '更新项目模板内容',
    id: 'updateProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/update',
  },
  {
    name: '新建项目模板',
    id: 'newProjectTemplate',
    method: 'post',
    urls: '/projects/project/template/new',
  },
  {
    name: '读取模板的生效部门',
    id: 'getScopeOfProjectTemplate',
    method: 'get',
    urls: '/projects/project/template/getScope',
  },
  {
    name: '读取待清理的项目列表',
    id: 'getProjectNeedClean',
    method: 'get',
    urls: '/projects/project/getCleanProjects',
  },
  {
    name: '更改自定义属性的顺序',
    id: 'exchangeCfPosition',
    method: 'post',
    urls: '/projects/project/template/customField/exchangePosition',
  }
];

const node2ProjectApis = {
  createSpace: {
    urls: '/projects/project/new',
  },
  createGroup: {
    urls: '/projects/project/newProjectSet',
  },
  searchProduct: {
    urls: '/projects/project/searchDivisions',
  },
  checkProjectName: {
    urls: '/projects/project/checkProjectName',
  },
  listProjectTemplates: {
    urls: '/projects/project/getProjectTemplate/listByDivision',
  },
  getProjectTemplateInfo: {
    urls: '/projects/project/getProjectTemplate/getInfo',
  },
  getProjectInfo: {
    urls: '/projects/project/getProjectInfo',
  },
  checkPermission: {
    urls: '/projects/project/checkPermission',
  },
  searchProSet: {
    urls: '/projects/project/searchProjectSetForNewOrUpdate',
  },
  searchForRelation: {
    urls: '/projects/project/searchForRelationToProjectSet',
  },
  getModuleTree: {
    urls: '/projects/module/tree/all',
  },
  deleteModule: {
    urls: '/projects/module/delete',
  },
  updateModule: {
    urls: '/projects/module/update',
  },
  getInheritModuleIds: {
    urls: '/projects/module/inheritance/getIds',
  },
  getParentProject: {
    urls: '/projects/project/getParentProject',
  },
  inheritModuleTree: {
    urls: '/projects/module/tree/parent',
  },
  getModuleDetail: {
    urls: '/projects/module/getDetail',
  },
  saveInheritModules: {
    urls: '/projects/module/inheritance/save',
  },
  searchModules: {
    urls: '/projects/module/parentModules',
  },
  createModule: {
    urls: '/projects/module/create',
  },
  subModuleTree: {
    urls: '/projects/module/subTree/all',
  },
  inheritSubModuleTree: {
    urls: '/projects/module/subTree/parent',
  },
  inheritParent: {
    urls: '/projects/module/inheritance/inheritParent',
  },
  updateModuleOwner: {
    urls: '/projects/module/updateOwner',
  },
  showProjectMember: {
    urls: '/projects/user/search',
  },
  newProjectTag: {
    urls: '/projects/tag/newProjectTag',
  },
  searchTags: {
    urls: '/projects/tag/searchTags',
  },
  shareTags: {
    urls: '/projects/tag/shareTags',
  },
  updateProjectTag: {
    urls: '/projects/tag/updateProjectTag',
  },
  delTaggingProject: {
    urls: '/projects/tag/deleteTag',
  },
  getVersionListOfProject: {
    urls: '/projects/version/getListOfProject',
  },
  createVersion: {
    urls: '/projects/version/newVersion',
  },
  getVersionListByParent: {
    urls: '/projects/version/getListByParent',
  },
  getVersionDetail: {
    urls: '/projects/version/getVersionDetail',
  },
  updateVersion: {
    urls: '/projects/version/updateVersion',
  },
  deleteVersion: {
    urls: '/projects/version/deleteVersion',
  },
  searchForEdit: {
    urls: '/projects/version/searchForEdit',
  },
  getCollabProjectSetting: {
    urls: '/projects/collab/getCollabProjectSetting',
  },
  selectGlobalRegionByGuid: {
    urls: '/projects/collab/searchGlobalRegionForCollab',
  },
  generateInviteCode: {
    urls: '/projects/collab/generateInviteCode',
  },
  setProjectCollab: {
    urls: '/projects/collab/setProjectCollab',
  },
  syncHistoryDataToCollabProject: {
    urls: '/projects/collab/syncHistoryDataToCollabProject',
  },
  listMembersForCollab: {
    urls: '/projects/collab/listMembers',
  },
  initiateCollabProject: {
    urls: '/projects/collab/initiate',
  },
  participateCollabProject: {
    urls: '/projects/collab/participate',
  },
  configSpaceService: {
    urls: '/projects/project/configProjectService',
  },
  getServices: {
    urls: '/projects/project/getAllServices',
  },
  recordRecentVisit: {
    urls: '/projects/project/recordRecentVisit'
  },
  getPermissionInProject: {
    urls: '/projects/project/getPermissionInProject'
  },
  quitProject: {
    urls: '/projects/member/quitProject'
  },
  getProjectDetail: {
    urls: '/projects/project/getProjectDetail'
  },
  searchParentSpaces: {
    urls: '/projects/project/searchForNewOrUpdate'
  },
  appInitGetApprovalStatus: {
    urls: '/projects/project/getApprovalStatus'
  },
  configProjectReqLock: {
    urls: '/projects/project/configProjectReqLock'
  },
  setProjectArchived: {
    urls: '/projects/project/archive'
  },
  setProjectActived: {
    urls: '/projects/project/active'
  },
  watchProject: {
    urls: '/projects/project/watcher/add'
  },
  addWatcher: {
    urls: '/projects/project/watcher/add'
  },
  cancleWatcher: {
    urls: '/projects/project/watcher/cancle'
  },
  cancelWatchProject: {
    urls: '/projects/project/watcher/cancle'
  },
  appInitNew: {
    urls: '/projects/approval/application/initiation/new'
  },
  appInitGetTemplate: {
    urls: '/projects/approval/application/initiation/appInitGetTemplate'
  },
  getProjectTemplateV2: {
    urls: '/projects/project/getProjectTemplate/createV2'
  },
  getProjectTemplateWhenUpdateV2: {
    urls: '/projects/project/getProjectTemplate/updateV2'
  },
  getCustomValues: {
    urls: '/projects/project/customField/getCustomValues'
  },
  getCustomFieldV2: {
    urls: '/projects/project/customField/getCustomFieldV2'
  },
  getOptionsOfExternal: {
    urls: '/projects/project/customField/getOptionsOfExternal'
  },
  getCustomOption: {
    urls: '/projects/project/customField/getCustomOption'
  },
  addChildProjects: {
    urls: '/projects/project/addChildProjects'
  },
  updateProject: {
    urls: '/projects/project/updateProject'
  },
  listSubPortfolios: {
    urls: '/projects/project/listSubPortfolios'
  },
  getRiskList: {
    urls: '/projects/project/risk/list'
  },
  getRiskSummary: {
    urls: '/projects/project/risk/summaryWithProgress'
  },
  getPortfolioMiniInfo: {
    urls: '/projects/project/getPortfolioMiniInfo'
  },
  getRiskRiseShowType: {
    urls: '/projects/project/getRiskRiseShowType'
  },
  setRiskRiseShowType: {
    urls: '/projects/project/setRiskRiseShowType'
  },
  portfolioTree: {
    method: 'post',
    urls: '/projects/project/portfolioComponent/tree'
  },
  portfolioSubTree: {
    urls: '/projects/project/portfolioComponent/subTree'
  },
  addRelatedComponents: {
    urls: '/projects/project/addRelatedComponents'
  },
  searchNewProduct: {
    urls: '/projects/project/searchProduct',
  },
  deleteProject: {
    urls: '/projects/project/deleteProject',
  },
  getMembersForEdit: {
    urls: '/projects/member/getMembersForEdit',
  },
  addMembers: {
    urls: '/projects/member/addMembers',
  },
  deleteMembers: {
    urls: '/projects/member/deleteMembers',
  },
  editMemRoles: {
    urls: '/projects/member/editMemRoles',
  },
  getProjectRolesForEdit: {
    urls: '/projects/member/getProjectRolesForEdit',
  },
  getMemberInfo: {
    urls: '/projects/member/getMemberInfo',
  },
  importMembers: {
    urls: '/projects/member/cloneMembers',
  },
  exportMembers: {
    urls: '/projects/member/exportMembers',
  },
  deleteProjectRoles: {
    urls: '/projects/member/deleteProjectRoles',
  },
  updateProjectRole: {
    urls: '/projects/member/updateProjectRole',
  },
  updateCustomRoleType: {
    urls: '/projects/member/updateCustomRoleType',
  },
  searchBreadList: {
    urls: '/projects/project/searchList',
  },
  getRoles: {
    urls: '/projects/member/getRoles',
  },
  getProjectInfoForDelete: {
    urls: '/projects/project/getProjectInfoForDelete',
  },
  cancelTaskForDelete: {
    urls: '/projects/project/cancelTaskForDelete',
  },
  updatePortfolio: {
    urls: '/projects/project/updatePortfolio',
  },
  getDefaultSpaceIcons: {
    urls: '/projects/project/getDefaultProjectIcons',
  },
  getTbProjectGroup: {
    urls: '/projects/tb/getProjectGroup',
  }
};


if (ifUseAkProjectApi) {
  apiOrigin = apiOrigin.map((a) => {
    if (typeof a === 'string') {
      const projectApi = node2ProjectApis[a];
      if (projectApi && projectApi.urls) {
        a = {
          name: a,
          id: a,
          urls: projectApi.urls,
      };
        if (projectApi.method) {
          a.method = projectApi.method;
        }
      }
    } else if (a.id) {
      const projectApi = node2ProjectApis[a.id];
      if (projectApi) {
        if (projectApi.method) {
          a.method = projectApi.method;
        }
        if (projectApi.urls) {
          a.urls = projectApi.urls;
        }
      }
    }
    return a;
  });
}
const api = apiOrigin;

export default api;



/** WEBPACK FOOTER **
 ** ./src/utils/api/api.js
 **/